/**
 * Generated by '@kontent-ai/model-generator@7.4.0'
 */
export const contentTypes = {
    /**
     *    Navigation Item
     */
    navigation_item: {
        codename: 'navigation_item',
        id: 'e42077b4-31e9-43d9-9f53-ebc65cefb9a4',
        externalId: undefined,
        name: '🌍 Navigation Item',
        elements: {
            /**
             * External URL (text)
             */
            external_url: {
                codename: 'external_url',
                id: 'c2445816-506d-4def-a473-cac9b060f9d8',
                externalId: undefined,
                name: 'External URL',
                required: false,
                type: 'text'
            },

            /**
             * Page (modular_content)
             */
            page: {
                codename: 'page',
                id: '926c7ebf-9f37-4d4d-94cc-3dec853a5aab',
                externalId: undefined,
                name: 'Page',
                required: false,
                type: 'modular_content'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'd95421ca-a13a-4a5f-8495-5b636bc3c8ba',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Navigation Section
     */
    navigation_section: {
        codename: 'navigation_section',
        id: 'c639afe9-12e7-49f2-9eaa-c3ed23867cce',
        externalId: undefined,
        name: '🌍 Navigation Section',
        elements: {
            /**
             * Navigation Items (modular_content)
             */
            navigation_items: {
                codename: 'navigation_items',
                id: '01df1096-a80e-4054-b335-cbd76209f4a1',
                externalId: undefined,
                name: 'Navigation Items',
                required: false,
                type: 'modular_content'
            }
        }
    },

    /**
     *    Script Tag
     */
    _script_tag: {
        codename: '_script_tag',
        id: '1ed91b72-5898-4cbb-8fef-c2e25119f512',
        externalId: undefined,
        name: '🌍 Script Tag',
        elements: {
            /**
             * Inner Code (text)
             */
            inner_code: {
                codename: 'inner_code',
                id: '6799dcbc-a2da-4d77-9dc7-e54590fbf1a1',
                externalId: undefined,
                name: 'Inner Code',
                required: false,
                type: 'text'
            },

            /**
             * Location (multiple_choice)
             */
            location: {
                codename: 'location',
                id: 'e3fb1f26-c776-4803-ac96-82fbd7f3b9b1',
                externalId: undefined,
                name: 'Location',
                required: false,
                type: 'multiple_choice',
                options: {
                    head: {
                        name: 'Head',
                        id: '590c83a3-bccb-40f8-b9b5-2d43b85ebd69',
                        codename: 'head',
                        externalId: undefined
                    },
                    body_open: {
                        name: 'Body Open',
                        id: 'eb5f9d93-cfc0-43be-90cf-679c98f04b7f',
                        codename: 'body_open',
                        externalId: undefined
                    },
                    body_close: {
                        name: 'Body Close',
                        id: '72b1b683-9a4e-41c8-8d76-3127f673a351',
                        codename: 'body_close',
                        externalId: undefined
                    }
                }
            },

            /**
             * URL (text)
             */
            url: {
                codename: 'url',
                id: 'b683f88f-30d1-40d7-acfb-737a395c256e',
                externalId: undefined,
                name: 'URL',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Site Configuration
     */
    site_configuration: {
        codename: 'site_configuration',
        id: '009a0d24-8c6a-42d3-bda5-1399e8fe7ff5',
        externalId: undefined,
        name: '🌍 Site Configuration',
        elements: {
            /**
             * Copyright Text (text)
             */
            copyright_text: {
                codename: 'copyright_text',
                id: '2c92b138-b702-40c3-8cb6-28f856ee463c',
                externalId: undefined,
                name: 'Copyright Text',
                required: false,
                type: 'text'
            },

            /**
             * Favicon (asset)
             */
            favicon: {
                codename: 'favicon',
                id: '2cd73b86-05a7-4a64-a7e9-773aafd9d973',
                externalId: undefined,
                name: 'Favicon',
                required: false,
                type: 'asset'
            },

            /**
             * LinkedIn Link (text)
             */
            linkedin_link: {
                codename: 'linkedin_link',
                id: 'f10eceb3-3ef8-45f6-b202-f560b390d2e3',
                externalId: undefined,
                name: 'LinkedIn Link',
                required: false,
                type: 'text'
            },

            /**
             * Navigation Header (modular_content)
             */
            navigation_header: {
                codename: 'navigation_header',
                id: 'b9fc5dbf-a4ca-4e94-b108-10e12c3ac710',
                externalId: undefined,
                name: 'Navigation Header',
                required: false,
                type: 'modular_content'
            },

            /**
             * Open Text (rich_text)
             */
            open_text: {
                codename: 'open_text',
                id: 'd51d38f2-7143-4723-a2e7-6e97d857fa68',
                externalId: undefined,
                name: 'Open Text',
                required: false,
                type: 'rich_text'
            },

            /**
             * Primary Navigation Links (modular_content)
             */
            primary_navigation_links: {
                codename: 'primary_navigation_links',
                id: '7fff262b-8de9-4a69-8a8a-e7dbfbce17d5',
                externalId: undefined,
                name: 'Primary Navigation Links',
                required: false,
                type: 'modular_content'
            },

            /**
             * Script Tags (modular_content)
             */
            script_tags: {
                codename: 'script_tags',
                id: 'd90c24e5-d59e-472a-b871-2128015adc87',
                externalId: undefined,
                name: 'Script Tags',
                required: false,
                type: 'modular_content'
            },

            /**
             * Secondary Navigation Links (modular_content)
             */
            secondary_navigation_links: {
                codename: 'secondary_navigation_links',
                id: '45a74d9a-a395-476b-b525-6927b853a3d5',
                externalId: undefined,
                name: 'Secondary Navigation Links',
                required: false,
                type: 'modular_content'
            },

            /**
             * Site Name (text)
             */
            site_name: {
                codename: 'site_name',
                id: '023ea4c5-db47-4799-977d-ffd03b9ccc7a',
                externalId: undefined,
                name: 'Site Name',
                required: false,
                type: 'text'
            },

            /**
             * TrustArc Code (text)
             */
            trustarc_code: {
                codename: 'trustarc_code',
                id: '343c521c-327a-4353-9349-40e6e7e39c4b',
                externalId: undefined,
                name: 'TrustArc Code',
                required: false,
                type: 'text'
            },

            /**
             * Twitter Link (text)
             */
            twitter_link: {
                codename: 'twitter_link',
                id: 'c17e7104-2292-4b5b-ae7d-b43e62d6d232',
                externalId: undefined,
                name: 'Twitter Link',
                required: false,
                type: 'text'
            },

            /**
             * Website Logo (asset)
             */
            website_logo: {
                codename: 'website_logo',
                id: 'abf1e1e4-0d10-41cb-924d-4b7f5419665d',
                externalId: undefined,
                name: 'Website Logo',
                required: false,
                type: 'asset'
            }
        }
    },

    /**
     *    Homepage
     */
    homepage: {
        codename: 'homepage',
        id: '1fae61af-97c6-484b-8714-321930ade690',
        externalId: undefined,
        name: '📄 Homepage',
        elements: {
            /**
             * Content (rich_text)
             */
            content_: {
                codename: 'content_',
                id: 'ca7641bb-2e53-414b-9610-fb800655595a',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Hero (modular_content)
             */
            hero: {
                codename: 'hero',
                id: '62326ab2-167d-40c2-86f8-d625a8a5b47d',
                externalId: undefined,
                name: 'Hero',
                required: false,
                type: 'modular_content'
            },

            /**
             * Meta Keywords (text)
             */
            seo_metadata__meta_keywords: {
                codename: 'seo_metadata__meta_keywords',
                id: 'f5552674-6a9f-4a33-97ce-bb42b7f2de2d',
                externalId: undefined,
                name: 'Meta Keywords',
                required: false,
                type: 'text',

                snippetCodename: 'seo_metadata'
            },

            /**
             * Social Share Preview (modular_content)
             */
            social_share_preview: {
                codename: 'social_share_preview',
                id: '59bfc465-9413-4ffa-9de8-dc8efc3241b1',
                externalId: undefined,
                name: 'Social Share Preview',
                required: false,
                type: 'modular_content'
            },

            /**
             * Subpages (subpages)
             */
            subpages: {
                codename: 'subpages',
                id: '798c8a1c-e017-43fd-9942-d0a0bc24601b',
                externalId: undefined,
                name: 'Subpages',
                required: false,
                type: 'subpages'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'b36ccce7-e033-4857-9625-a3f19ac2443b',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * URL Slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: 'd7c3b4d4-c122-4c73-bf78-c629bfbe60a3',
                externalId: undefined,
                name: 'URL Slug',
                required: false,
                type: 'url_slug'
            }
        }
    },

    /**
     *    Interior Page
     */
    interior_page: {
        codename: 'interior_page',
        id: '4af0eb08-41b9-4dfe-a4b1-1b73fe5be6fd',
        externalId: undefined,
        name: '📄 Interior Page',
        elements: {
            /**
             * Banner (modular_content)
             */
            banner: {
                codename: 'banner',
                id: '2ecc18b8-bdd8-4f38-9858-a64ead4e2870',
                externalId: undefined,
                name: 'Banner',
                required: false,
                type: 'modular_content'
            },

            /**
             * Content (rich_text)
             */
            content_: {
                codename: 'content_',
                id: '68539c63-d1f9-4dd8-827a-956b213a515d',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Meta Keywords (text)
             */
            seo_metadata__meta_keywords: {
                codename: 'seo_metadata__meta_keywords',
                id: 'f5552674-6a9f-4a33-97ce-bb42b7f2de2d',
                externalId: undefined,
                name: 'Meta Keywords',
                required: false,
                type: 'text',

                snippetCodename: 'seo_metadata'
            },

            /**
             * Social Share Preview (modular_content)
             */
            social_share_preview: {
                codename: 'social_share_preview',
                id: '58366dc6-989f-4030-a898-a7f41bd754de',
                externalId: undefined,
                name: 'Social Share Preview',
                required: false,
                type: 'modular_content'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'd524d56b-fa01-44b0-878a-ff46e1f82e96',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * URL Slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: '1e80a5b9-4cd8-4039-b2d9-056bd0fda119',
                externalId: undefined,
                name: 'URL Slug',
                required: false,
                type: 'url_slug'
            }
        }
    },

    /**
     *    Platform Page
     */
    platform_page: {
        codename: 'platform_page',
        id: 'b75b1a69-cf24-4567-8350-d056c23211d9',
        externalId: undefined,
        name: '📄 Platform Page',
        elements: {
            /**
             * Banner (modular_content)
             */
            banner: {
                codename: 'banner',
                id: 'bf7f1c3d-59b2-4287-8979-b9dd30737609',
                externalId: undefined,
                name: 'Banner',
                required: false,
                type: 'modular_content'
            },

            /**
             * Content (rich_text)
             */
            content_: {
                codename: 'content_',
                id: 'ffb85717-1ffc-4db9-82a5-2bc33b1a2c5f',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Meta Keywords (text)
             */
            seo_metadata__meta_keywords: {
                codename: 'seo_metadata__meta_keywords',
                id: 'f5552674-6a9f-4a33-97ce-bb42b7f2de2d',
                externalId: undefined,
                name: 'Meta Keywords',
                required: false,
                type: 'text',

                snippetCodename: 'seo_metadata'
            },

            /**
             * Social Share Preview (modular_content)
             */
            social_share_preview: {
                codename: 'social_share_preview',
                id: '0e81fedf-f07d-4009-b36d-ccbd518254f9',
                externalId: undefined,
                name: 'Social Share Preview',
                required: false,
                type: 'modular_content'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '9d4f1564-91fd-4c87-8962-70e64a4eb116',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * URL Slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: 'ef8599be-556b-4075-9bf2-612bc2b29067',
                externalId: undefined,
                name: 'URL Slug',
                required: false,
                type: 'url_slug'
            }
        }
    },

    /**
     *    Anchor Tag
     */
    anchor_tag: {
        codename: 'anchor_tag',
        id: 'f1be32af-4f49-401f-b222-267f11480ce6',
        externalId: undefined,
        name: '🔠 Anchor Tag',
        elements: {
            /**
             * ID (text)
             */
            id: {
                codename: 'id',
                id: 'b3ec5730-bf31-44a0-81f5-0a787444a406',
                externalId: undefined,
                name: 'ID',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Call to Action
     */
    call_to_action: {
        codename: 'call_to_action',
        id: '485f6636-d857-45dc-b7c8-88b23888523e',
        externalId: undefined,
        name: '🔠 Call to Action',
        elements: {
            /**
             * Email Address (text)
             */
            email_address: {
                codename: 'email_address',
                id: '4785856a-c554-41fd-9cb1-9808ebec1ba1',
                externalId: undefined,
                name: 'Email Address',
                required: false,
                type: 'text'
            },

            /**
             * Generic Asset Target (asset)
             */
            generic_asset_target: {
                codename: 'generic_asset_target',
                id: '8cd629c8-f6cc-4ef0-b9b2-c436ddd7e9b3',
                externalId: undefined,
                name: 'Generic Asset Target',
                required: false,
                type: 'asset'
            },

            /**
             * Link Title (text)
             */
            link_title: {
                codename: 'link_title',
                id: 'a79d15c8-0cff-425e-ae91-41d1ea3f0c8a',
                externalId: undefined,
                name: 'Link Title',
                required: false,
                type: 'text'
            },

            /**
             * Linked Target (modular_content)
             */
            linked_target: {
                codename: 'linked_target',
                id: 'caea6467-380f-4d8b-b1a2-db47ba21d2fb',
                externalId: undefined,
                name: 'Linked Target',
                required: false,
                type: 'modular_content'
            },

            /**
             * Manual Target (text)
             */
            manual_target: {
                codename: 'manual_target',
                id: '2cf10235-b9fd-4fc2-b8eb-d0af76fdcbb6',
                externalId: undefined,
                name: 'Manual Target',
                required: false,
                type: 'text'
            },

            /**
             * Phone Number (rich_text)
             */
            phone_number: {
                codename: 'phone_number',
                id: 'ef8c8c24-2ec3-4cbc-baf4-2642a2973e62',
                externalId: undefined,
                name: 'Phone Number',
                required: false,
                type: 'rich_text'
            },

            /**
             * Styling Options (multiple_choice)
             */
            styling_options: {
                codename: 'styling_options',
                id: 'c2954c11-60d8-4b85-9a10-03ad05ff31bc',
                externalId: undefined,
                name: 'Styling Options',
                required: true,
                type: 'multiple_choice',
                options: {
                    button: {
                        name: 'Button',
                        id: '668586aa-323c-432e-b212-f9b63ad3c17d',
                        codename: 'button',
                        externalId: undefined
                    },
                    text_w__arrow: {
                        name: 'Text w  Arrow',
                        id: 'cd4cf6fe-af90-4055-8f56-84efeb6f6ece',
                        codename: 'text_w__arrow',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     *    Icon Item
     */
    icon_item: {
        codename: 'icon_item',
        id: '0f102a3e-14e1-4ae4-b89f-692be7c7f394',
        externalId: undefined,
        name: '🔠 Icon Item',
        elements: {
            /**
             * Description (text)
             */
            description: {
                codename: 'description',
                id: '608dffb4-454a-4906-8cb7-3f2ce136c976',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'text'
            },

            /**
             * Icon (asset)
             */
            icon: {
                codename: 'icon',
                id: '14fe9cb3-6cb6-4b59-9839-27497116dca2',
                externalId: undefined,
                name: 'Icon',
                required: true,
                type: 'asset'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '906c7060-d2c2-4b95-a5a5-2c7925c06840',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Logo Item
     */
    logo_item: {
        codename: 'logo_item',
        id: '9f3ba842-16c1-48b7-bf97-b0824b1e4e2d',
        externalId: undefined,
        name: '🔠 Logo Item',
        elements: {
            /**
             * Link (text)
             */
            link: {
                codename: 'link',
                id: 'd155179b-b2f4-4b21-9652-34d21c510daf',
                externalId: undefined,
                name: 'Link',
                required: false,
                type: 'text'
            },

            /**
             * Logo (asset)
             */
            logo: {
                codename: 'logo',
                id: '27b452b5-cd05-4a54-8365-dc8604529916',
                externalId: undefined,
                name: 'Logo',
                required: false,
                type: 'asset'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'babe435f-404a-4430-8f54-91f2738a8932',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Module
     */
    module_item: {
        codename: 'module_item',
        id: '8d503ae7-e834-4350-9653-3fc09f722253',
        externalId: undefined,
        name: '🔠 Module',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '1342ea82-3780-42e7-84fe-dfbd80a1f44b',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Contributors (modular_content)
             */
            contributors: {
                codename: 'contributors',
                id: '42270617-f66f-4354-b602-bd84ed016403',
                externalId: undefined,
                name: 'Contributors',
                required: false,
                type: 'modular_content'
            },

            /**
             * Modalities (taxonomy)
             */
            modality: {
                codename: 'modality',
                id: 'c781f91f-5628-451e-9f56-93fecb8496f9',
                externalId: undefined,
                name: 'Modalities',
                required: false,
                type: 'taxonomy'
            },

            /**
             * Module Title (text)
             */
            module_title: {
                codename: 'module_title',
                id: '20f5b95a-68bc-4143-a141-ad483646488f',
                externalId: undefined,
                name: 'Module Title',
                required: false,
                type: 'text'
            },

            /**
             * Short Description (text)
             */
            short_description: {
                codename: 'short_description',
                id: '9fb4d023-d73c-4325-8da5-f82a774bdb01',
                externalId: undefined,
                name: 'Short Description',
                required: false,
                type: 'text'
            },

            /**
             * Social Share Preview (modular_content)
             */
            social_share_preview: {
                codename: 'social_share_preview',
                id: '23c47bf8-914e-4273-b7d4-b0fe63a192cd',
                externalId: undefined,
                name: 'Social Share Preview',
                required: false,
                type: 'modular_content'
            },

            /**
             * URL Slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: 'f10f4868-0c8f-49ea-a37f-4b9d8d3c0b06',
                externalId: undefined,
                name: 'URL Slug',
                required: false,
                type: 'url_slug'
            }
        }
    },

    /**
     *    Partner
     */
    partner_item: {
        codename: 'partner_item',
        id: 'a4c3f03e-26f0-454c-ab6b-3c4b15de5839',
        externalId: undefined,
        name: '🔠 Partner',
        elements: {
            /**
             * Call to Action (modular_content)
             */
            call_to_action: {
                codename: 'call_to_action',
                id: '27f566ff-7817-4b45-9e41-d1388d217f35',
                externalId: undefined,
                name: 'Call to Action',
                required: false,
                type: 'modular_content'
            },

            /**
             * Collaborators (modular_content)
             */
            collaborators: {
                codename: 'collaborators',
                id: '29b248ed-2c10-4588-ad76-84340254321e',
                externalId: undefined,
                name: 'Collaborators',
                required: false,
                type: 'modular_content'
            },

            /**
             * Logo (asset)
             */
            logo: {
                codename: 'logo',
                id: '653caab0-371f-4267-9ece-21d505e1924e',
                externalId: undefined,
                name: 'Logo',
                required: false,
                type: 'asset'
            },

            /**
             * Long Description (rich_text)
             */
            long_description: {
                codename: 'long_description',
                id: '8f95dea1-d191-4029-ad38-e95deff702b4',
                externalId: undefined,
                name: 'Long Description',
                required: false,
                type: 'rich_text'
            },

            /**
             * Modalities (taxonomy)
             */
            modality: {
                codename: 'modality',
                id: '85012422-eefc-4348-b03c-8240eb50e1df',
                externalId: undefined,
                name: 'Modalities',
                required: false,
                type: 'taxonomy'
            },

            /**
             * Modules (modular_content)
             */
            modules: {
                codename: 'modules',
                id: '2d685067-132d-4beb-ad88-ff26315d6360',
                externalId: undefined,
                name: 'Modules',
                required: false,
                type: 'modular_content'
            },

            /**
             * Partner Title (text)
             */
            partner_title: {
                codename: 'partner_title',
                id: '878c8b47-afd4-46aa-be2f-8142992fc407',
                externalId: undefined,
                name: 'Partner Title',
                required: false,
                type: 'text'
            },

            /**
             * Short Description (text)
             */
            short_description: {
                codename: 'short_description',
                id: '5548639e-6055-46e7-ba12-50a577a2a3c4',
                externalId: undefined,
                name: 'Short Description',
                required: false,
                type: 'text'
            },

            /**
             * Social Share Preview (modular_content)
             */
            social_share_preview: {
                codename: 'social_share_preview',
                id: '71407b29-1c29-4332-b362-8fcdfeb2ade2',
                externalId: undefined,
                name: 'Social Share Preview',
                required: false,
                type: 'modular_content'
            },

            /**
             * URL Slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: '3954819e-bb6d-4f97-8c2d-2f776cab59bd',
                externalId: undefined,
                name: 'URL Slug',
                required: false,
                type: 'url_slug'
            }
        }
    },

    /**
     *    Publication Item
     */
    _publication_item: {
        codename: '_publication_item',
        id: '4abba03a-2750-44af-9ba6-e5c6bb3d9502',
        externalId: undefined,
        name: '🔠 Publication Item',
        elements: {
            /**
             * Author Information (text)
             */
            author_information: {
                codename: 'author_information',
                id: 'da5ef501-c2ac-4790-a7a6-1a3aaa49e646',
                externalId: undefined,
                name: 'Author Information',
                required: false,
                type: 'text'
            },

            /**
             * Link to Publication (text)
             */
            link_to_publication: {
                codename: 'link_to_publication',
                id: '50c76660-2501-45f8-bf28-534c5c859735',
                externalId: undefined,
                name: 'Link to Publication',
                required: false,
                type: 'text'
            },

            /**
             * Publication Date (date_time)
             */
            publication_date: {
                codename: 'publication_date',
                id: '93128f9d-6704-436b-be1d-629f00a649a5',
                externalId: undefined,
                name: 'Publication Date',
                required: false,
                type: 'date_time'
            },

            /**
             * Publication Title (text)
             */
            publication_title: {
                codename: 'publication_title',
                id: 'dd71edbf-9a65-4d63-ab13-fed2ef3c787c',
                externalId: undefined,
                name: 'Publication Title',
                required: false,
                type: 'text'
            },

            /**
             * News Type (taxonomy)
             */
            publication_type: {
                codename: 'publication_type',
                id: '497d7506-7f0a-4a56-8ef0-a5dcac7b5f98',
                externalId: undefined,
                name: 'Publication Type',
                required: false,
                type: 'taxonomy'
            }
        }
    },

    /**
     *    Rich Text   Horizontal Rule
     */
    _horizontal_rule: {
        codename: '_horizontal_rule',
        id: '11e5d2e2-50e7-495d-af6b-33f81570ac43',
        externalId: undefined,
        name: '🔠 Rich Text - Horizontal Rule',
        elements: {
            /**
             * BackgrounD Color (multiple_choice)
             */
            background_color: {
                codename: 'background_color',
                id: 'c13ed733-c345-45ae-a8a5-7f7e629b97ba',
                externalId: undefined,
                name: 'BackgrounD Color',
                required: false,
                type: 'multiple_choice',
                options: {
                    white: {
                        name: 'White',
                        id: 'd6b17e68-1674-453a-8af0-a40125e2b0bd',
                        codename: 'white',
                        externalId: undefined
                    },
                    navy: {
                        name: 'Navy',
                        id: '0cfa1ece-075e-433e-918e-c34e2e992e5f',
                        codename: 'navy',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     *    Social Share Preview
     */
    _social_share_preview: {
        codename: '_social_share_preview',
        id: '716606bc-29e0-4ae8-8602-cc0cfc83fe8d',
        externalId: undefined,
        name: '🔠 Social Share Preview',
        elements: {
            /**
             * Description (text)
             */
            description: {
                codename: 'description',
                id: 'b506b0a5-64b3-42d1-8c9f-6c7db5f580a2',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'text'
            },

            /**
             * Image (asset)
             */
            image: {
                codename: 'image',
                id: '03a23259-81d6-4611-8209-3b9e5908bcea',
                externalId: undefined,
                name: 'Image',
                required: false,
                type: 'asset'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'ab587e4e-4efa-4c18-b437-c20d96198de9',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Split Content Block   Basic Content
     */
    split_content_block_basic_content: {
        codename: 'split_content_block_basic_content',
        id: '8ca18d70-ef8c-4fbb-953c-4ab73b7670c3',
        externalId: undefined,
        name: '🔠 Split Content Block - Basic Content',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '73e27434-f8a5-423e-95c0-e395949b64dc',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '7859be66-8f98-4130-8463-92b8ff389539',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Split Content Block   Image
     */
    split_content_block_image: {
        codename: 'split_content_block_image',
        id: '832eab3a-2307-4624-a0d6-cb762290d4ea',
        externalId: undefined,
        name: '🔠 Split Content Block - Image',
        elements: {
            /**
             * Caption (rich_text)
             */
            caption: {
                codename: 'caption',
                id: '8ce3b245-6006-4945-9e66-3300c356e4fd',
                externalId: undefined,
                name: 'Caption',
                required: false,
                type: 'rich_text'
            },

            /**
             * Caption Styling (multiple_choice)
             */
            caption_styling: {
                codename: 'caption_styling',
                id: '72b7d641-59f8-4816-90e6-3d56e67aa9b7',
                externalId: undefined,
                name: 'Caption Styling',
                required: false,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'Light',
                        id: 'b89fec5d-1478-4f3d-99a7-0acc28e1b31f',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'Dark',
                        id: '7673f65c-5382-4956-bf66-a549a606fc1e',
                        codename: 'dark',
                        externalId: undefined
                    }
                }
            },

            /**
             * Image (asset)
             */
            image: {
                codename: 'image',
                id: 'a8d2c2f9-5c63-4878-8fbe-c85a4f4c1f6b',
                externalId: undefined,
                name: 'Image',
                required: true,
                type: 'asset'
            },

            /**
             * Link (text)
             */
            link: {
                codename: 'link',
                id: 'cba99ccd-2a5d-4f9b-aff9-ebc195c928ae',
                externalId: undefined,
                name: 'Link',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Team Member
     */
    team_member: {
        codename: 'team_member',
        id: 'f6ccce32-c77f-4a7f-a3da-18e82466943e',
        externalId: undefined,
        name: '🔠 Team Member',
        elements: {
            /**
             * Description (rich_text)
             */
            description: {
                codename: 'description',
                id: '4dbf06b9-9bd7-4acb-8cb7-7badd8fc4adf',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'rich_text'
            },

            /**
             * Image (asset)
             */
            image: {
                codename: 'image',
                id: 'd129c163-b023-49c2-a099-f033a6497ffa',
                externalId: undefined,
                name: 'Image',
                required: false,
                type: 'asset'
            },

            /**
             * LinkedIn (text)
             */
            linkedin: {
                codename: 'linkedin',
                id: '3c953751-c0de-4130-94e3-d12be725e80a',
                externalId: undefined,
                name: 'LinkedIn',
                required: false,
                type: 'text'
            },

            /**
             * Name (text)
             */
            name: {
                codename: 'name',
                id: '6f9e52cf-70ec-4b05-82a0-49d76145ef0a',
                externalId: undefined,
                name: 'Name',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Accordion Content Block
     */
    accordion_content_block: {
        codename: 'accordion_content_block',
        id: '1f081813-a5a6-460a-86dc-26f723a2de16',
        externalId: undefined,
        name: '🧩 Accordion Content Block',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: 'c15dee90-9c62-4511-b4de-9138025f84d8',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Default State (multiple_choice)
             */
            default_state: {
                codename: 'default_state',
                id: '744bf8bb-a2e7-4f73-98ea-55d8fd4ca4dc',
                externalId: undefined,
                name: 'Default State',
                required: true,
                type: 'multiple_choice',
                options: {
                    open: {
                        name: 'Open',
                        id: '0db915fe-7e44-4e57-9147-2c53c5d43276',
                        codename: 'open',
                        externalId: undefined
                    },
                    closed: {
                        name: 'Closed',
                        id: '9daa1fce-f927-4a13-84a6-60cbf8340714',
                        codename: 'closed',
                        externalId: undefined
                    }
                }
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'a5fe6004-b5e5-4ca2-8f46-f8b37564dabd',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No top padding',
                        id: '9be2946a-d91c-4790-a58b-fae042355b28',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No bottom padding',
                        id: 'd7bbea3a-35e0-4d44-9785-9ca6c0640849',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Read More Character Count (number)
             */
            read_more_character_count: {
                codename: 'read_more_character_count',
                id: 'badafe42-5536-4d3e-bc15-35b4e113cee1',
                externalId: undefined,
                name: 'Read More Character Count',
                required: false,
                type: 'number'
            },

            /**
             * Subtitle (text)
             */
            subtitle: {
                codename: 'subtitle',
                id: '72393042-6fb5-4ec6-adfe-4d41ac7dd918',
                externalId: undefined,
                name: 'Subtitle',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '0bdf72c2-b5ab-489d-b464-bdf846839933',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Anchor Navigation Bar
     */
    _anchor_navigation_bar: {
        codename: '_anchor_navigation_bar',
        id: '1b335942-ec3d-4a76-86aa-5353bf86d43b',
        externalId: undefined,
        name: '🧩 Anchor Navigation Bar',
        elements: {}
    },

    /**
     *    Announcement Banner
     */
    _announcement_banner: {
        codename: '_announcement_banner',
        id: '2faad4c9-43d6-40c9-88e7-5bb96195a416',
        externalId: undefined,
        name: '🧩 Announcement Banner',
        elements: {
            /**
             * Call to Action (modular_content)
             */
            call_to_action: {
                codename: 'call_to_action',
                id: 'cf883d9a-631e-4a34-a100-ed3a0c0b3a4f',
                externalId: undefined,
                name: 'Call to Action',
                required: false,
                type: 'modular_content'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'b5f432fe-f9bc-4c6e-9587-26135cf0f528',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Banner
     */
    banner: {
        codename: 'banner',
        id: '2ab97f0f-866e-4445-97b5-e35eeae6f1ac',
        externalId: undefined,
        name: '🧩 Banner',
        elements: {
            /**
             * Call to Action (modular_content)
             */
            call_to_action: {
                codename: 'call_to_action',
                id: '90d7c39e-418c-4bbf-b198-465025fa5f7e',
                externalId: undefined,
                name: 'Call to Action',
                required: false,
                type: 'modular_content'
            },

            /**
             * Design (multiple_choice)
             */
            design: {
                codename: 'design',
                id: 'b3ddb287-f87a-4d90-8832-408ee86e1eb8',
                externalId: undefined,
                name: 'Design',
                required: false,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'Light',
                        id: '62b0ded3-7138-410b-afdd-5da35c938ca2',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'Dark',
                        id: 'e66751c0-61f4-461c-a6dc-dbaaf234ece1',
                        codename: 'dark',
                        externalId: undefined
                    }
                }
            },

            /**
             * Image (asset)
             */
            image: {
                codename: 'image',
                id: '15925187-49b2-4b45-b24d-6df97221d86b',
                externalId: undefined,
                name: 'Image',
                required: false,
                type: 'asset'
            },

            /**
             * Image Placement (multiple_choice)
             */
            image_placement: {
                codename: 'image_placement',
                id: 'b097b9bf-9084-45b0-97d4-6592ae7a5728',
                externalId: undefined,
                name: 'Image Placement',
                required: false,
                type: 'multiple_choice',
                options: {
                    left: {
                        name: 'Left',
                        id: '8c3a203a-1d43-4cfe-8c6c-22066de5168c',
                        codename: 'left',
                        externalId: undefined
                    },
                    right: {
                        name: 'Right',
                        id: '0268eb3a-4403-49d7-891c-3734eba88ee4',
                        codename: 'right',
                        externalId: undefined
                    }
                }
            },

            /**
             * Layout (multiple_choice)
             */
            layout: {
                codename: 'layout',
                id: 'ee024255-488d-4d14-be74-011c731fc4a8',
                externalId: undefined,
                name: 'Layout',
                required: true,
                type: 'multiple_choice',
                options: {
                    split: {
                        name: 'Split',
                        id: 'b18057f8-81de-4272-96db-78c0e8e2828c',
                        codename: 'split',
                        externalId: undefined
                    },
                    full_width: {
                        name: 'Full Width',
                        id: '3d6f2706-4290-40b1-8fe3-6fd6a5807f5d',
                        codename: 'full_width',
                        externalId: undefined
                    }
                }
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'a5fe6004-b5e5-4ca2-8f46-f8b37564dabd',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No top padding',
                        id: '9be2946a-d91c-4790-a58b-fae042355b28',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No bottom padding',
                        id: 'd7bbea3a-35e0-4d44-9785-9ca6c0640849',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Primary Content (rich_text)
             */
            primary_content: {
                codename: 'primary_content',
                id: '890d4726-b95e-4141-afa5-a57cafd57d41',
                externalId: undefined,
                name: 'Primary Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Secondary Content (rich_text)
             */
            secondary_content: {
                codename: 'secondary_content',
                id: '232612e5-10a7-4a84-94ff-a0d3ac3554f1',
                externalId: undefined,
                name: 'Secondary Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '266ad707-1d3f-4871-8d78-c584253116cc',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Basic Content Block
     */
    basic_content_block: {
        codename: 'basic_content_block',
        id: 'aead985b-2cf4-4cab-8e98-8c4117e28d36',
        externalId: undefined,
        name: '🧩 Basic Content Block',
        elements: {
            /**
             * Background Color (multiple_choice)
             */
            background_color: {
                codename: 'background_color',
                id: 'f025261e-46a5-4c1b-a5cb-b41325fd1bb1',
                externalId: undefined,
                name: 'Background Color',
                required: true,
                type: 'multiple_choice',
                options: {
                    white: {
                        name: 'White',
                        id: '2b050b42-96a7-44be-a4a1-5088fe4a0cdf',
                        codename: 'white',
                        externalId: undefined
                    },
                    navy: {
                        name: 'Navy',
                        id: '24ce0004-c23c-4bc0-a24c-4dc49de71ec1',
                        codename: 'navy',
                        externalId: undefined
                    }
                }
            },

            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: 'fd1e0b92-3af6-4e04-a308-260e765bb36d',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'a5fe6004-b5e5-4ca2-8f46-f8b37564dabd',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No top padding',
                        id: '9be2946a-d91c-4790-a58b-fae042355b28',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No bottom padding',
                        id: 'd7bbea3a-35e0-4d44-9785-9ca6c0640849',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'dd1e015a-eb77-49d3-9304-1b3bc6bc1a25',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Contact Block
     */
    contact_block: {
        codename: 'contact_block',
        id: '96178443-5ea2-4019-a40e-b3f293e26bdc',
        externalId: undefined,
        name: '🧩 Contact Block',
        elements: {
            /**
             * Call to Action (modular_content)
             */
            call_to_action: {
                codename: 'call_to_action',
                id: 'bd6a1cb6-e55a-40dc-8015-a08b751e3382',
                externalId: undefined,
                name: 'Call to Action',
                required: false,
                type: 'modular_content'
            },

            /**
             * Description (rich_text)
             */
            description: {
                codename: 'description',
                id: 'cb58fd08-3c0f-4869-af7c-c1faf0005f70',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'rich_text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'ab468c45-8c33-49ba-bd95-112491e87668',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Icon Collection
     */
    icon_collection: {
        codename: 'icon_collection',
        id: '59cc733b-b3eb-4be9-a635-4a1e078b1483',
        externalId: undefined,
        name: '🧩 Icon Collection',
        elements: {
            /**
             * Icon Items (modular_content)
             */
            icon_items: {
                codename: 'icon_items',
                id: '4bad5075-31b2-4d3a-8e8e-ef0870a8106f',
                externalId: undefined,
                name: 'Icon Items',
                required: false,
                type: 'modular_content'
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'a5fe6004-b5e5-4ca2-8f46-f8b37564dabd',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No top padding',
                        id: '9be2946a-d91c-4790-a58b-fae042355b28',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No bottom padding',
                        id: 'd7bbea3a-35e0-4d44-9785-9ca6c0640849',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '9994cc4f-79c6-41f2-989b-3a3aad0bd204',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    iFrame
     */
    iframe: {
        codename: 'iframe',
        id: '26b66c60-9f6d-4661-88f3-2a10c575ac71',
        externalId: undefined,
        name: '🧩 iFrame',
        elements: {
            /**
             * Height (number)
             *
             * This can be from any content resolution since it will just be a basis for getting the iframe content's aspect ratio.
             */
            height: {
                codename: 'height',
                id: '078c2f51-ee0c-45c9-9ca4-0fce4f9b7d7a',
                externalId: undefined,
                name: 'Height',
                required: false,
                type: 'number'
            },

            /**
             * iFrame Code (text)
             */
            iframe_code: {
                codename: 'iframe_code',
                id: 'b1b479fd-602c-4021-9fa5-41503b4013ba',
                externalId: undefined,
                name: 'iFrame Code',
                required: false,
                type: 'text'
            },

            /**
             * Width (number)
             *
             * This can be from any content resolution since it will just be a basis for getting the iframe content's aspect ratio.
             */
            width: {
                codename: 'width',
                id: '21f67b88-b081-4247-a26b-6dab11e32fbf',
                externalId: undefined,
                name: 'Width',
                required: false,
                type: 'number'
            }
        }
    },

    /**
     *    Image Block
     */
    image_block: {
        codename: 'image_block',
        id: '220b130a-7af8-488a-b5ca-a2ce4cb70a13',
        externalId: undefined,
        name: '🧩 Image Block',
        elements: {
            /**
             * Caption (text)
             */
            caption: {
                codename: 'caption',
                id: 'f2a03553-3da6-46e6-afc6-f2220dcd5240',
                externalId: undefined,
                name: 'Caption',
                required: false,
                type: 'text'
            },

            /**
             * Caption Styling (multiple_choice)
             */
            caption_styling: {
                codename: 'caption_styling',
                id: 'd487aa98-bec6-480e-8789-f549ea03a30c',
                externalId: undefined,
                name: 'Caption Styling',
                required: false,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'Light',
                        id: '9d8a195b-0d82-4ba9-a9db-151a3ffa7067',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'Dark',
                        id: 'c0f4179b-2e56-4945-9e24-f61450faab25',
                        codename: 'dark',
                        externalId: undefined
                    }
                }
            },

            /**
             * Image (asset)
             */
            image: {
                codename: 'image',
                id: 'f7dd3eea-ea8a-472d-9c50-670eedd60083',
                externalId: undefined,
                name: 'Image',
                required: true,
                type: 'asset'
            },

            /**
             * Link (text)
             */
            link: {
                codename: 'link',
                id: '6b6b4930-70ef-4ce7-bc45-839b592d6faf',
                externalId: undefined,
                name: 'Link',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Logo Collection
     */
    logo_collection: {
        codename: 'logo_collection',
        id: '1ec019ab-aaed-4ac2-99d6-cb8c6702ad49',
        externalId: undefined,
        name: '🧩 Logo Collection',
        elements: {
            /**
             * Description (text)
             */
            description: {
                codename: 'description',
                id: '1ac3abd1-aa24-4675-b694-c81034ee461f',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'text'
            },

            /**
             * Logo Items (modular_content)
             */
            logo_items: {
                codename: 'logo_items',
                id: 'ca2a80b3-8e31-49c5-8b40-c81ba55d5f7f',
                externalId: undefined,
                name: 'Logo Items',
                required: false,
                type: 'modular_content'
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'a5fe6004-b5e5-4ca2-8f46-f8b37564dabd',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No top padding',
                        id: '9be2946a-d91c-4790-a58b-fae042355b28',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No bottom padding',
                        id: 'd7bbea3a-35e0-4d44-9785-9ca6c0640849',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Styling Options (multiple_choice)
             */
            styling_options: {
                codename: 'styling_options',
                id: '1ec89889-5c1d-44f8-a519-6e946dfeac05',
                externalId: undefined,
                name: 'Styling Options',
                required: true,
                type: 'multiple_choice',
                options: {
                    image_only: {
                        name: 'Image Only',
                        id: '4f49475c-1018-4299-824f-29e102b2c23d',
                        codename: 'image_only',
                        externalId: undefined
                    },
                    image_and_title: {
                        name: 'Image and Title',
                        id: '8fa17144-2b2e-40bf-928f-56106f4c00e7',
                        codename: 'image_and_title',
                        externalId: undefined
                    }
                }
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'c3c2c7b6-0fdd-4df6-a03e-5c3880ed20c6',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Media Block
     */
    media_block: {
        codename: 'media_block',
        id: '827f7f48-810f-4b9f-a676-3382b0343a5b',
        externalId: undefined,
        name: '🧩 Media Block',
        elements: {
            /**
             * Background Color (multiple_choice)
             */
            background_color: {
                codename: 'background_color',
                id: '6d054a09-de6d-467a-96ab-219fa8bac687',
                externalId: undefined,
                name: 'Background Color',
                required: false,
                type: 'multiple_choice',
                options: {
                    white: {
                        name: 'White',
                        id: '1bac6468-98fd-4826-9e0d-748228138a43',
                        codename: 'white',
                        externalId: undefined
                    },
                    navy: {
                        name: 'Navy',
                        id: '66fa228d-07a2-402a-ad7b-0fa615b0dfa8',
                        codename: 'navy',
                        externalId: undefined
                    },
                    pale_blue: {
                        name: 'Pale Blue',
                        id: '5ff34a3c-9d3c-45a4-978a-946633a860f2',
                        codename: 'pale_blue',
                        externalId: undefined
                    },
                    jade: {
                        name: 'Jade',
                        id: 'f506135f-37aa-4caa-8245-320db5c49db0',
                        codename: 'jade',
                        externalId: undefined
                    }
                }
            },

            /**
             * Background Image (asset)
             */
            background_image: {
                codename: 'background_image',
                id: '87e6ef1c-4802-4445-b1b5-f91a251f511e',
                externalId: undefined,
                name: 'Background Image',
                required: false,
                type: 'asset'
            },

            /**
             * Iframe (modular_content)
             */
            iframe: {
                codename: 'iframe',
                id: '990db064-d313-4723-906f-2e972d622bcc',
                externalId: undefined,
                name: 'Iframe',
                required: false,
                type: 'modular_content'
            },

            /**
             * Image Style (multiple_choice)
             */
            image_style: {
                codename: 'image_style',
                id: 'b2b568af-922b-43f6-b1fa-93a83368af70',
                externalId: undefined,
                name: 'Image Style',
                required: false,
                type: 'multiple_choice',
                options: {
                    image_background: {
                        name: 'Image Background',
                        id: 'e61facc9-3ab0-4cc3-b9a6-368120cb359a',
                        codename: 'image_background',
                        externalId: undefined
                    }
                }
            },

            /**
             * Mobile Background Image (asset)
             */
            mobile_background_image: {
                codename: 'mobile_background_image',
                id: 'dc0f030b-0f4c-4617-8d36-95e901b24521',
                externalId: undefined,
                name: 'Mobile Background Image',
                required: false,
                type: 'asset'
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'a5fe6004-b5e5-4ca2-8f46-f8b37564dabd',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No top padding',
                        id: '9be2946a-d91c-4790-a58b-fae042355b28',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No bottom padding',
                        id: 'd7bbea3a-35e0-4d44-9785-9ca6c0640849',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Primary Image (asset)
             */
            primary_image: {
                codename: 'primary_image',
                id: '8ef0853a-dd1f-4668-968d-45f3a2afecd4',
                externalId: undefined,
                name: 'Primary Image',
                required: false,
                type: 'asset'
            },

            /**
             * Primary Mobile Image s  (asset)
             */
            primary_mobile_images: {
                codename: 'primary_mobile_images',
                id: 'caeab466-4a67-4750-b267-f7e350acf4de',
                externalId: undefined,
                name: 'Primary Mobile Image(s)',
                required: false,
                type: 'asset'
            },

            /**
             * Video Embed (text)
             */
            video_embed: {
                codename: 'video_embed',
                id: '4b050a58-b0f3-44d2-b1a1-41d8b5feb394',
                externalId: undefined,
                name: 'Video Embed',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    News   Media List
     */
    news_media_list: {
        codename: 'news_media_list',
        id: 'c60cf097-f2f5-44bd-93e9-2d4a9430cf3b',
        externalId: undefined,
        name: '🧩 News & Media List',
        elements: {
            /**
             * Highlights (modular_content)
             */
            highlights: {
                codename: 'highlights',
                id: '18f82f8c-a3e0-4be8-9756-0cf3291ae80b',
                externalId: undefined,
                name: 'Highlights',
                required: false,
                type: 'modular_content'
            },

            /**
             * Number of Conferences to display (number)
             */
            number_of_conferences_to_display: {
                codename: 'number_of_conferences_to_display',
                id: 'a6ba0458-de34-49e8-9665-3a95384fec24',
                externalId: undefined,
                name: 'Number of Conferences to display',
                required: false,
                type: 'number'
            },

            /**
             * Number of Highlights to display (number)
             */
            number_of_items_to_display: {
                codename: 'number_of_items_to_display',
                id: '8b40b3fe-10a3-46d6-bb98-19d6ce744bbd',
                externalId: undefined,
                name: 'Number of Highlights to display',
                required: false,
                type: 'number'
            },

            /**
             * Number of Press Releases to display (number)
             */
            number_of_press_releases_to_display: {
                codename: 'number_of_press_releases_to_display',
                id: 'd4bffdad-b9fb-47aa-bfd7-2a3e69178a06',
                externalId: undefined,
                name: 'Number of Press Releases to display',
                required: false,
                type: 'number'
            },

            /**
             * Number of Publications to display (number)
             */
            number_of_all_publications_to_display: {
                codename: 'number_of_all_publications_to_display',
                id: '868917f3-eee3-437a-8b48-59991465d0fe',
                externalId: undefined,
                name: 'Number of Publications to display',
                required: false,
                type: 'number'
            }
        }
    },

    /**
     *    Partner List
     */
    partner_list: {
        codename: 'partner_list',
        id: '2e975e9a-44cd-43ff-b087-19e3cb0bfa39',
        externalId: undefined,
        name: '🧩 Partner List',
        elements: {
            /**
             * Partners (modular_content)
             */
            partners: {
                codename: 'partners',
                id: 'b2524c4a-787a-41bb-b984-709efb63c1b2',
                externalId: undefined,
                name: 'Partners',
                required: false,
                type: 'modular_content'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '79318dc2-dcdc-4d77-b849-767ce0ad6183',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Platform Page Basic Content Block
     */
    platform_page_basic_content_block: {
        codename: 'platform_page_basic_content_block',
        id: '1435051b-124e-4234-bcad-1b37c2c5d55e',
        externalId: undefined,
        name: '🧩 Platform Page Basic Content Block',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '8d656682-e6cc-431f-a384-eaf6e1832eee',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'a5fe6004-b5e5-4ca2-8f46-f8b37564dabd',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No top padding',
                        id: '9be2946a-d91c-4790-a58b-fae042355b28',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No bottom padding',
                        id: 'd7bbea3a-35e0-4d44-9785-9ca6c0640849',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Show in Anchor Bar (multiple_choice)
             */
            show_in_anchor_bar: {
                codename: 'show_in_anchor_bar',
                id: 'e6df5979-49bc-4b4e-a530-21576f6335c7',
                externalId: undefined,
                name: 'Show in Anchor Bar',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'f2e1d792-e02c-4282-8dc7-3e805e88fbaf',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'e391de7f-a76e-42c8-b062-39860b8e868e',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '83badd4a-51a9-4b4f-b9a6-a3ad22f5af0a',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Platform Page Split Content Block
     */
    platform_page_split_content_block: {
        codename: 'platform_page_split_content_block',
        id: 'd43f8c82-9c84-4bae-a0ec-5e21af321973',
        externalId: undefined,
        name: '🧩 Platform Page Split Content Block',
        elements: {
            /**
             * Background (multiple_choice)
             */
            background: {
                codename: 'background',
                id: 'c70ce62b-1924-4cc3-ba5c-a28dfbfe7e4d',
                externalId: undefined,
                name: 'Background',
                required: false,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'Light',
                        id: '127f1797-ce3f-4077-b495-58e57363b995',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'Dark',
                        id: '6bc5aed5-4d76-4398-9c12-9cc338f33db7',
                        codename: 'dark',
                        externalId: undefined
                    }
                }
            },

            /**
             * Layout (multiple_choice)
             */
            layout: {
                codename: 'layout',
                id: 'fec392e1-22f6-4282-9c14-5133e6ace81b',
                externalId: undefined,
                name: 'Layout',
                required: false,
                type: 'multiple_choice',
                options: {
                    n50_50: {
                        name: '50 50',
                        id: '9a6f0246-301e-410a-a5d4-27b981def1ff',
                        codename: 'n50_50',
                        externalId: undefined
                    }
                }
            },

            /**
             * Left Content (rich_text)
             */
            left_content: {
                codename: 'left_content',
                id: 'ca75ba1e-f4e9-4d10-ae0b-29937f0365d8',
                externalId: undefined,
                name: 'Left Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Menu Title (text)
             */
            menu_title: {
                codename: 'menu_title',
                id: '03d4bad2-9336-4043-97e2-cc5deb9933ff',
                externalId: undefined,
                name: 'Menu Title',
                required: false,
                type: 'text'
            },

            /**
             * Mobile Layout (multiple_choice)
             */
            mobile_layout: {
                codename: 'mobile_layout',
                id: 'bd65ee31-f618-47bd-9133-ed9646370fe9',
                externalId: undefined,
                name: 'Mobile Layout',
                required: false,
                type: 'multiple_choice',
                options: {
                    left_content_on_top: {
                        name: 'Left content on top',
                        id: 'f3a6074c-f29d-42ce-aa70-9d888d0a4eff',
                        codename: 'left_content_on_top',
                        externalId: undefined
                    },
                    right_content_on_top: {
                        name: 'Right content on top',
                        id: 'f589310f-1fc2-41fc-b91f-6f306479d5c4',
                        codename: 'right_content_on_top',
                        externalId: undefined
                    }
                }
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'a5fe6004-b5e5-4ca2-8f46-f8b37564dabd',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No top padding',
                        id: '9be2946a-d91c-4790-a58b-fae042355b28',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No bottom padding',
                        id: 'd7bbea3a-35e0-4d44-9785-9ca6c0640849',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Right Content (rich_text)
             */
            right_content: {
                codename: 'right_content',
                id: '1867267c-11ce-495f-96c2-b0976e8c1a44',
                externalId: undefined,
                name: 'Right Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Show in Anchor Bar (multiple_choice)
             */
            show_in_anchor_bar: {
                codename: 'show_in_anchor_bar',
                id: 'f9df26fa-f8bc-48e9-b77e-57047030436e',
                externalId: undefined,
                name: 'Show in Anchor Bar',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '919a56ac-c9af-407d-905e-ae3ac57f3b20',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '01d2630e-e679-417a-bacc-d2415af5f7c3',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'ff13712d-a8f0-4e91-a10d-11e0899ac5a8',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Section Break
     */
    section_break: {
        codename: 'section_break',
        id: '3d6194d5-d2a7-448c-a11c-7f5953272dcb',
        externalId: undefined,
        name: '🧩 Section Break',
        elements: {
            /**
             * Design (multiple_choice)
             */
            design: {
                codename: 'design',
                id: 'cc151c20-dae0-4613-a5c3-c66c74cd5c13',
                externalId: undefined,
                name: 'Design',
                required: true,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'Light',
                        id: 'f4a420a1-4192-4adb-bc49-bce89dd9bf60',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'Dark',
                        id: '1425d5d8-1aff-48c1-bcab-b376fcaaa416',
                        codename: 'dark',
                        externalId: undefined
                    },
                    image: {
                        name: 'Image',
                        id: '85717d48-78f3-4ff3-99cd-a9eef0f052c4',
                        codename: 'image',
                        externalId: undefined
                    }
                }
            },

            /**
             * Image (asset)
             */
            image: {
                codename: 'image',
                id: '219ef258-d5ba-46cf-b514-8febfcb583ec',
                externalId: undefined,
                name: 'Image',
                required: false,
                type: 'asset'
            }
        }
    },

    /**
     *    Split Content Block
     */
    split_content_block: {
        codename: 'split_content_block',
        id: '2fa28af1-198c-4b51-9382-b267ab0d655c',
        externalId: undefined,
        name: '🧩 Split Content Block',
        elements: {
            /**
             * Background (multiple_choice)
             */
            background: {
                codename: 'background',
                id: 'e72380a4-9f0c-44f4-9e2f-af0af48d1280',
                externalId: undefined,
                name: 'Background',
                required: false,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'Light',
                        id: '40af847b-ff0b-4685-9933-2087a545e490',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'Dark',
                        id: 'a071c0ff-701a-4043-b39b-e24ec3f18898',
                        codename: 'dark',
                        externalId: undefined
                    }
                }
            },

            /**
             * Layout (multiple_choice)
             */
            layout: {
                codename: 'layout',
                id: 'cdca08dc-cf53-4eda-84e9-b748d4a4b685',
                externalId: undefined,
                name: 'Layout',
                required: false,
                type: 'multiple_choice',
                options: {
                    n50_50: {
                        name: '50 50',
                        id: '9b1f80eb-e1d4-42b4-ae67-49b781af5068',
                        codename: 'n50_50',
                        externalId: undefined
                    },
                    n30_70: {
                        name: '30 70',
                        id: 'de7b7e00-63d8-4b50-ba86-5cf79320a866',
                        codename: 'n30_70',
                        externalId: undefined
                    },
                    n70_30: {
                        name: '70 30',
                        id: 'b393b08a-8fed-491e-9d76-64685cdb23f1',
                        codename: 'n70_30',
                        externalId: undefined
                    }
                }
            },

            /**
             * Left Content (rich_text)
             */
            left_content: {
                codename: 'left_content',
                id: 'b9d32b7d-fdb8-4856-901e-3fd53f809458',
                externalId: undefined,
                name: 'Left Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Menu Title (text)
             */
            menu_title: {
                codename: 'menu_title',
                id: '655e70bb-eb41-4111-a5aa-6c2e8b87db80',
                externalId: undefined,
                name: 'Menu Title',
                required: false,
                type: 'text'
            },

            /**
             * Mobile Layout (multiple_choice)
             */
            mobile_layout: {
                codename: 'mobile_layout',
                id: '9c9f6c5c-b218-4d80-8abb-e01c84b31f83',
                externalId: undefined,
                name: 'Mobile Layout',
                required: false,
                type: 'multiple_choice',
                options: {
                    left_content_on_top: {
                        name: 'Left content on top',
                        id: '998423de-b3e7-40b3-8409-de4f8eb080ae',
                        codename: 'left_content_on_top',
                        externalId: undefined
                    },
                    right_content_on_top: {
                        name: 'Right content on top',
                        id: '4fbd4c47-7fac-4343-984c-db14462d5601',
                        codename: 'right_content_on_top',
                        externalId: undefined
                    }
                }
            },

            /**
             * Padding Modifications (multiple_choice)
             */
            padding_modifications__padding_modifications: {
                codename: 'padding_modifications__padding_modifications',
                id: 'a5fe6004-b5e5-4ca2-8f46-f8b37564dabd',
                externalId: undefined,
                name: 'Padding Modifications',
                required: false,
                type: 'multiple_choice',
                options: {
                    no_top_padding: {
                        name: 'No top padding',
                        id: '9be2946a-d91c-4790-a58b-fae042355b28',
                        codename: 'no_top_padding',
                        externalId: undefined
                    },
                    no_bottom_padding: {
                        name: 'No bottom padding',
                        id: 'd7bbea3a-35e0-4d44-9785-9ca6c0640849',
                        codename: 'no_bottom_padding',
                        externalId: undefined
                    }
                },
                snippetCodename: 'padding_modifications'
            },

            /**
             * Right Content (rich_text)
             */
            right_content: {
                codename: 'right_content',
                id: 'f2284cca-666f-4c7d-8e09-21c75caba46e',
                externalId: undefined,
                name: 'Right Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '9f3c6d74-4026-4e78-8a62-89f8bc881738',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     *    Team List
     */
    team_list: {
        codename: 'team_list',
        id: '80023eb5-c161-4195-8498-5cca68ae17ff',
        externalId: undefined,
        name: '🧩 Team List',
        elements: {
            /**
             * Description (text)
             */
            description: {
                codename: 'description',
                id: '0e448371-de34-4e6f-b516-99b6c9e288c2',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'text'
            },

            /**
             * Styling Options (multiple_choice)
             */
            styling_options: {
                codename: 'styling_options',
                id: '0df49b81-0869-4de9-9a58-175b763051b4',
                externalId: undefined,
                name: 'Styling Options',
                required: false,
                type: 'multiple_choice',
                options: {
                    name_and_description_only: {
                        name: 'Name and Description only',
                        id: '84c3c41b-f741-468f-ab9f-415a94c19027',
                        codename: 'name_and_description_only',
                        externalId: undefined
                    },
                    full_information: {
                        name: 'Full Information',
                        id: 'b3649ab6-76ea-4060-a624-abab3fc68b85',
                        codename: 'full_information',
                        externalId: undefined
                    }
                }
            },

            /**
             * Team (modular_content)
             */
            team: {
                codename: 'team',
                id: '85eeb9e8-6a55-4662-8ad7-013b21124f76',
                externalId: undefined,
                name: 'Team',
                required: false,
                type: 'modular_content'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'bdeac26c-c531-425d-9a1b-22cd68990427',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Web spotlight root
     */
    web_spotlight_root: {
        codename: 'web_spotlight_root',
        id: 'db7aba37-89f2-4298-9fa6-6716d9c65a80',
        externalId: undefined,
        name: 'Web spotlight root',
        elements: {
            /**
             * Content (modular_content)
             */
            content: {
                codename: 'content',
                id: '6d811740-e9c5-46c3-b955-d805c938e57a',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'modular_content'
            },

            /**
             * Subpages (subpages)
             */
            subpages: {
                codename: 'subpages',
                id: '4e9a6424-7a81-49f3-91d2-dba42924ed0a',
                externalId: undefined,
                name: 'Subpages',
                required: false,
                type: 'subpages'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '52c178ed-ecc7-4b33-b2c3-a996c09077d9',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    }
} as const;
